import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// Attach auth token to every request if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ace_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ace_token');
      localStorage.removeItem('ace_user');
    }
    return Promise.reject(err);
  }
);

// === AUTH ===
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  getMe: () => api.get('/auth/me'),
  createUser: (data) => api.post('/auth/users', data),
};

// === COMPANIES ===
export const companiesAPI = {
  list: () => api.get('/companies'),
  create: (data) => api.post('/companies', data),
  update: (id, data) => api.put(`/companies/${id}`, data),
  remove: (id) => api.delete(`/companies/${id}`),
};

// === CARDS ===
export const cardsAPI = {
  list: (companyId) => api.get('/cards', { params: companyId ? { company_id: companyId } : {} }),
  create: (data) => api.post('/cards', data),
  update: (id, data) => api.put(`/cards/${id}`, data),
  remove: (id) => api.delete(`/cards/${id}`),
  getPublic: (slug) => api.get(`/cards/public/${slug}`),
};

// === VCARD ===
export const vcardAPI = {
  download: (slug) => `${API_BASE}/vcard/${slug}`,
};

// === INQUIRIES ===
export const inquiriesAPI = {
  create: (data) => api.post('/inquiries', data),
  list: () => api.get('/inquiries'),
};

// === LEADS ===
export const leadsAPI = {
  create: (data) => api.post('/leads', data),
  list: () => api.get('/leads'),
  exportCSV: () => `${API_BASE}/leads/export?token=${localStorage.getItem('ace_token')}`,
};

// === FILE UPLOAD ===
export const uploadAPI = {
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

// === DASHBOARD ===
export const dashboardAPI = {
  stats: () => api.get('/dashboard/stats'),
};

// === CRON ===
export const cronAPI = {
  checkExpiry: () => api.get('/cron/check-expiry'),
};

export const settingsAPI = {
  getAll: () => api.get('/settings'),
  get: (key) => api.get(`/settings/${key}`),
  update: (key, value) => api.put(`/settings/${key}`, { value }),
};

export default api;
